<ng-template transloco let-t>
  <app-header />
  <mat-sidenav-container>
    <mat-sidenav [opened]="visibleSideNav$()" mode="side" class="sidenav">
      <mat-nav-list>
        <mat-list-item [disableRipple]="true" routerLink="/locations" routerLinkActive="active" #locActive="routerLinkActive">
          <app-svg-selector class="me-1"
                            [type]="locActive.isActive ? 'color' : 'white-b-color'"
                            svg="company"
                            [size]="1.75" />
          <span class="align-middle text-truncate">{{ t("location.list") }}</span>
        </mat-list-item>
        <mat-list-item [disableRipple]="true" routerLink="/sea-routes" routerLinkActive="active" #seaRoutesActive="routerLinkActive">
          <app-svg-selector class="me-1"
                            [type]="seaRoutesActive.isActive ? 'color' : 'white-b-color'"
                            svg="vessel"
                            [size]="1.75" />
          <span class="align-middle text-truncate">{{ t("sea-routes.list") }}</span>
        </mat-list-item>
        <mat-list-item [disableRipple]="true" routerLink="/vessels" routerLinkActive="active" #vesselsActive="routerLinkActive">
          <app-svg-selector class="me-1"
                            [type]="vesselsActive.isActive ? 'color' : 'white-b-color'"
                            svg="vessel"
                            [size]="1.75" />
          <span class="align-middle text-truncate">{{ t("vessels.list") }}</span>
        </mat-list-item>
        <mat-list-item [disableRipple]="true" routerLink="/operators" routerLinkActive="active" #operatorsActive="routerLinkActive">
          <app-svg-selector class="me-1"
                            [type]="operatorsActive.isActive ? 'color' : 'white-b-color'"
                            svg="company"
                            [size]="1.75" />
          <span class="align-middle text-truncate">{{ t("operators.list") }}</span>
        </mat-list-item>
        <mat-list-item [disableRipple]="true" routerLink="/perimeters" routerLinkActive="active" #perimetersActive="routerLinkActive">
          <app-svg-selector class="me-1"
                            [type]="perimetersActive.isActive ? 'color' : 'white-b-color'"
                            svg="company"
                            [size]="1.75" />
          <span class="align-middle text-truncate">{{ t("perimeters.list") }}</span>
        </mat-list-item>
        <mat-list-item [disableRipple]="true" routerLink="/contracts" routerLinkActive="active" #contractsActive="routerLinkActive">
          <app-svg-selector class="me-1"
                            [type]="contractsActive.isActive ? 'color' : 'white-b-color'"
                            svg="container"
                            [size]="1.75" />
          <span class="align-middle text-truncate">{{ t("contracts.list") }}</span>
        </mat-list-item>
      </mat-nav-list>
      <div class="divider"></div>
      <mat-nav-list>
        <mat-list-item [disableRipple]="true" routerLink="/organizations/list/" routerLinkActive="active" #orgActive="routerLinkActive">
          <app-svg-selector class="me-1"
                            [type]="orgActive.isActive ? 'color' : 'white-b-color'"
                            svg="customer"
                            [size]="1.75" />
          <span class="align-middle text-truncate">{{ t("organization.list") }}</span>
        </mat-list-item>
        <mat-list-item [disableRipple]="true" routerLink="/users" routerLinkActive="active" #usrActive="routerLinkActive">
          <app-svg-selector class="me-1"
                            [type]="usrActive.isActive ? 'color' : 'white-b-color'"
                            svg="profile"
                            [size]="1.75" />
          <span class="align-middle text-truncate">{{ t("users.list") }}</span>
        </mat-list-item>
      </mat-nav-list>
      <div class="divider"></div>
      <mat-nav-list>
        <mat-list-item [disableRipple]="true" routerLink="/shipments" routerLinkActive="active" #shpActive="routerLinkActive">
          <app-svg-selector class="me-1"
                            [type]="shpActive.isActive ? 'color' : 'white-b-color'"
                            svg="container"
                            [size]="1.75" />
          <span class="align-middle text-truncate">{{ t("shipments.list") }}</span>
        </mat-list-item>
        <mat-list-item [disableRipple]="true" routerLink="/prestation-models" routerLinkActive="active" #jrnActive="routerLinkActive">
          <app-svg-selector class="me-1"
                            [type]="jrnActive.isActive ? 'color' : 'white-b-color'"
                            svg="truck"
                            [size]="1.75" />
          <span class="align-middle text-truncate">{{ t("prestationModels.list") }}</span>
        </mat-list-item>
      </mat-nav-list>
      <div class="divider"></div>
      <mat-nav-list>
        <mat-list-item [disableRipple]="true" routerLink="/settings" routerLinkActive="active" #settingsActive="routerLinkActive">
          <mat-icon class="me-1 align-middle" [style.color]="settingsActive.isActive ? '#607D8B' : '#FFFFFF'" style="font-size: 1.75rem; width: 1.75rem; height: 1.75rem;">settings</mat-icon>
          <span class="align-middle text-truncate">{{ t("app.settings") }}</span>
        </mat-list-item>
      </mat-nav-list>
    </mat-sidenav>
    <mat-sidenav-content>
      <router-outlet />
    </mat-sidenav-content>
  </mat-sidenav-container>
</ng-template>
